module.exports = __webpack_public_path__ + "static/media/screen-full.f8780646.svg";